'use client';

import * as React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { useTranslate } from '@tolgee/react';

import abiLogo from '~/assets/images/abi_logo.png';
import { useResponsive } from '~/shared/hooks';

import { MobileMenu } from '../Nav/components/MobileMenu';

export function HeaderActions() {
  const { t } = useTranslate();
  const { isMobile, isTablet } = useResponsive({ useOnlyAbiTokens: true });

  return (
    <div className="flex items-center gap-4">
      {(isTablet || isMobile) && <MobileMenu />}
      <Link href="/home" style={{ textDecoration: 'none' }}>
        <div className="flex items-center gap-2">
          <div className="hidden text-[0] md:block">
            <Image src={abiLogo} alt="Ab InBev" />
          </div>
          <span className="bg-[linear-gradient(90deg,#D3A238_0%,#F5E003_60%)] bg-clip-text text-2xl leading-tight font-bold tracking-normal text-transparent">
            {t('common.brand_name')}
          </span>
        </div>
      </Link>
    </div>
  );
}
